/**
 * Facts about one thing, as a real `<dl>`.
 *
 * A two-column table would look identical and be wrong: a table announces
 * rows and columns and invites a screen-reader user to navigate them, when
 * what is here is a set of labelled values about a single subject. `<dl>` says
 * that, and costs nothing.
 *
 * `readOnly` marks a group whose values come from somewhere this application
 * does not control — an ERP, typically — so the interface can say so once
 * instead of putting a disabled input around every value.
 */

import type { ReactNode } from "react";

import "./data.css";

export interface Definition {
  label: string;
  value: ReactNode;
}

export interface DefinitionListProps {
  items: readonly Definition[];
  /** Two columns instead of label-above-value. Denser, for long lists. */
  layout?: "stacked" | "inline";
}

export function DefinitionList({ items, layout = "inline" }: DefinitionListProps) {
  return (
    <dl className="hardauto-definitions" data-layout={layout}>
      {items.map((item) => (
        <div className="hardauto-definitions__row" key={item.label}>
          <dt className="hardauto-definitions__label">{item.label}</dt>
          <dd className="hardauto-definitions__value">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
